import { render, staticRenderFns } from "./AdminRealmView.vue?vue&type=template&id=4e2e1527&scoped=true&"
import script from "./AdminRealmView.vue?vue&type=script&lang=js&"
export * from "./AdminRealmView.vue?vue&type=script&lang=js&"
import style0 from "./AdminRealmView.vue?vue&type=style&index=0&id=4e2e1527&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2e1527",
  null
  
)

export default component.exports